<template>
    <LayoutDefault>
        <div
              class="container"
              id="movie_index"
        >
            <section class="categories">
                <h3
                        v-if="filters.search"
                        class="title"
                >
                    {{$t('video_index.search_title')}}
                </h3>
                <h3
                        v-else
                        class="title"
                >
                    {{$t('video_index.title')}}
                </h3>
                <template v-if="!loadingMovies && !errorMovies">
                    <template v-if="movies.length > 0">
                        <div class="movies">
                            <VideoBox
                                    v-for="movie in movies"
                                    :video="movie"
                                    :key="movie.id"
                            />
                        </div>
                        <div class="movies-footer">
                            <button
                                    v-if="moviesCurrentPage"
                                    @click.prevent="loadMoreMovies"
                            >
                                {{$t('load_more')}}
                            </button>
                            <Spinner v-if="loadingMoreMovies"/>
                        </div>
                    </template>
                    <div
                            class="no-results-found"
                            v-if="movies.length === 0"
                    >
                        <p>
                            {{$t('noRecords')}}
                        </p>
                    </div>
                </template>
                <template v-else>
                    <Spinner v-if="loadingMovies"/>
                    <template v-if="errorMovies">
                        <p>
                            {{$t('error')}}
                        </p>
                        <button
                                type="button"
                                @click="loadMovies"
                        >
                            {{$t('retry')}}
                        </button>
                    </template>
                </template>
            </section>
        </div>
    </LayoutDefault>
</template>

<script>
    import VideoBox from '../components/VideoBox';
    import Spinner from '../components/Spinner';
    import EventBus from './../eventbus';

    import resources from '../resources';
    import LayoutDefault from "../layouts/LayoutDefault";

    const resultsPerPage = 16;

    export default {
        components: {
            LayoutDefault,
            VideoBox,
            Spinner
        },
        methods: {
            updateFilters(){
                this.filters.search = this.$route.query.search || '';

                this.filters.categories = {
                    id: this.$route.query.category_id || null
                };

                this.filters.group = {
                    id: this.$route.query.group_id || null
                };
            },
            loadMovies(){
                this.updateFilters();

                this.loadingMovies = true;
                this.loadingMoreMovies = false;
                this.moviesCurrentPage = null;
                this.errorMovies = false;
                this.movies = null;

                resources.movies.index(Object.assign({}, this.filteredFilters, {per_page: resultsPerPage, page: 1}))
                    .then((response) => {
                        this.loadingMovies = false;
                        this.movies = response.data.data;

                        if(response.data.data.length === resultsPerPage){
                            this.moviesCurrentPage = 1;
                        }else{
                            this.moviesCurrentPage = null;
                        }

                        //Guardamos historial
                        resources.movieSearchs.store({search: JSON.stringify(this.filteredFilters)});
                    }).catch(() => {
                        this.loadingMovies = false;
                        this.errorMovies = true;
                    });
            },
            loadMoreMovies(){
                this.loadingMoreMovies = true;

                resources.movies.index(Object.assign({}, this.filteredFilters, {per_page: resultsPerPage, page: this.moviesCurrentPage + 1}))
                    .then(response => {
                        this.loadingMoreMovies = false;
                        this.movies = this.movies.concat(response.data.data);

                        if(response.data.data.length === resultsPerPage){
                            this.moviesCurrentPage++;
                        }else{
                            this.moviesCurrentPage = null;
                        }
                    }).catch(() =>{
                        this.loadingMoreMovies = false;
                    });
            },
        },
        data(){
            return {
                filters: {
                    search: this.$route.query.search || '',
                    categories: {
                        id: this.$route.query.category_id || null
                    },
                    tags: {
                        id: this.$route.query.tag_id || null
                    },
                    models: {
                        id: this.$route.query.model_id || null
                    },
                    group: {
                        id: this.$route.query.group_id || null
                    }
                },
                loadingMoreMovies: false,
                moviesCurrentPage: null,
                loadingMovies: true,
                errorMovies: false,
                movies: null
            }
        },
        watch: {
            $route: function(){
                this.loadMovies();
            }
        },
        computed: {
            filteredFilters(){
                let filters = {};

                if(this.filters.search){
                    filters.search = this.filters.search;
                }

                if(this.filters.categories.id){
                    filters.categories = {
                        id: this.filters.categories.id
                    };
                }

                if(this.filters.tags.id){
                    filters.tags = {
                        id: this.filters.tags.id
                    };
                }

                if(this.filters.models.id){
                    filters.models = {
                        id: this.filters.models.id
                    };
                }

                if(this.filters.group.id){
                    filters.group = {
                        id: this.filters.group.id
                    };
                }

                return filters;
            },
        },
        mounted(){
            this.loadMovies();

            EventBus.$on('languageChanged', () => {
                this.loadMovies();
            });
        },
        beforeRouteUpdate(from, to, next){
            this.loadMovies();

            next();
        },
    }
</script>

<style scoped lang="scss">
    @import '../styles/variables';

  #movie_index{
    background-color: var(--pallete_clear_color);
    min-height: 500px;
    padding: 9px;
    padding-bottom: 50px;

    .movies{
      display: flex;
      flex-wrap: wrap;
      margin: 0 -5px;

      .video{
        flex-grow: 0;
        margin-bottom: 30px;
        flex-basis: 25%;

        @media(max-width: 900px){
          flex-basis: 50%;
        }

        @media(max-width: 600px){
          flex-basis: 100%;
        }
      }
    }

    .movies-footer {
        margin: 25px 0;
        text-align: center;

        button {
            padding: .5em 1.5em;
            font-size: 1.5em;
        }
    }

    .no-results-found {
        padding: 2rem 0;
        text-align: center;
    }
  }
</style>
